import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ButtonComponentEvent } from '../button/button.component';

@Component({
	selector: 'app-table-widget-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent extends WidgetComponent implements OnInit {

	// tslint:disable-next-line: deprecation
	constructor(ngEl: ElementRef, renderer: Renderer2) {
		super(ngEl, renderer);
	}

	ngOnInit() {
	}

	setChange($event: MatCheckboxChange): void {
		if (!$event.checked) {
			this.tableColumn.checked = false;
		}
		this.tableElement.setSelected($event.checked);
		this.table.onButtonClicked(new ButtonComponentEvent(this.tableElement, this.tableColumn));
	}

	onClicked($event: any): void {
		$event.stopPropagation();
	}

}
